import { Checkbox as HeadlessUICheckbox } from "@headlessui/react";
import clsx from "clsx";
import { Icon } from "../icons";

/** Props Interface */
interface CheckboxProps {
	name?: string;
	value?: boolean;
	onChange?: (e: boolean) => void;
	isDisabled?: boolean;
	isIndeterminate?: boolean;
	"data-cy"?: string;
	tabIndex?: number;
}

export function Checkbox({
	name,
	value,
	onChange,
	isDisabled,
	isIndeterminate,
	"data-cy": cyId,
	tabIndex,
}: CheckboxProps) {
	return (
		<HeadlessUICheckbox
			id={name}
			checked={value}
			onChange={onChange}
			onClick={(e) => e.stopPropagation()}
			disabled={isDisabled}
			tabIndex={tabIndex}
			className={clsx(
				"ui-checkbox",
				"shrink-0 flex-center bg-white dark:bg-primary-800 w-4 h-4 aspect-square",
				"cursor-pointer",
				"shadow-xs",
				"border-[0.5px] border-solid!",
				"border-primary-200! dark:border-primary-700!",
				"data-checked:border-primary-700! data-checked:dark:border-accent-700!",
				"rounded-sm",
				"overflow-hidden",
				"text-xs",
				"focus:border-accent-500! focus:dark:border-accent-500!",
				isDisabled && "cursor-not-allowed! opacity-50 bg-primary-100! dark:bg-primary-950!",
			)}
			data-cy={cyId}
		>
			{value && (
				<div className="flex-center bg-primary-700 dark:bg-accent-500 w-full h-full">
					<Icon
						name={isIndeterminate ? "Minus" : "Check"}
						className="text-[0.6rem] text-white dark:text-white"
						size={9}
					/>
				</div>
			)}
		</HeadlessUICheckbox>
	);
}
